import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { PageTitle } from './ui';
import { useCatalogFilters } from './catalog/useCatalogFilters';
import { CatalogToolbar } from './catalog/CatalogToolbar';
import { CatalogFilters } from './catalog/CatalogFilters';
import { CatalogResults } from './catalog/CatalogResults';
export { ProductCard } from './catalog/ProductCard';

export default function Catalog() {
  const model = useCatalogFilters();
  const query = model.params.get('q') || '';
  return <div className="container catalog-page">
    <div className="breadcrumb"><Link data-testid="catalog-home-crumb" to="/">Home</Link><ChevronRight size={12} />Industrial catalog</div>
    <PageTitle eyebrow="THE INDUSTRIAL CATALOG" title="The right parts. The right partners.">
      Products and services for your next big project.
    </PageTitle>
    <CatalogToolbar query={query} sort={model.params.get('sort') || 'featured'} update={model.update}
      filtersOpen={model.filtersOpen} toggleFilters={model.toggleFilters} />
    <div className="catalog-layout">
      <CatalogFilters model={model} />
      <CatalogResults remote={model.products} query={query} clearQuery={() => model.update('q', '')} />
    </div>
  </div>;
}